import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootPrintApiManager_ds_get_materials_by_materialCodes_projectIdService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { materialCodes: string[], projectId: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, PackagingLookups?: { PackagingId?: number, SubPackagingId?: number }[] }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.materialCodes)) {
      missingRequiredInParams.push('\'materialCodes\'');
    }
    if (isNil(inParams.projectId)) {
      missingRequiredInParams.push('\'projectId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { materialCodes: string[], projectId: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, PackagingLookups?: { PackagingId?: number, SubPackagingId?: number }[] }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.materialCodes)) {
      missingRequiredInParams.push('\'materialCodes\'');
    }
    if (isNil(inParams.projectId)) {
      missingRequiredInParams.push('\'projectId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { materialCodes: string[], projectId: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string, PackagingLookups?: { PackagingId?: number, SubPackagingId?: number }[] }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.materialCodes)) {
      missingRequiredInParams.push('\'materialCodes\'');
    }
    if (isNil(inParams.projectId)) {
      missingRequiredInParams.push('\'projectId\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      materialCodes: string[], projectId: number    }) {
        if(isNil(inParams.materialCodes)) {
          return true; 
        }
        if(isNil(inParams.projectId)) {
          return true; 
        }
      return false;
    }
}
